import ObjetivoService from 'src/modules/objetivo/objetivoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'OBJETIVO_FORM';

const objetivoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: objetivoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ObjetivoService.find(id);
      }

      dispatch({
        type: objetivoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objetivoFormActions.INIT_ERROR,
      });

      getHistory().push('/objetivo');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: objetivoFormActions.CREATE_STARTED,
      });

      await ObjetivoService.create(values);

      dispatch({
        type: objetivoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.objetivo.create.success'),
      );

      getHistory().push('/objetivo');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objetivoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: objetivoFormActions.UPDATE_STARTED,
      });

      await ObjetivoService.update(id, values);

      dispatch({
        type: objetivoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.objetivo.update.success'),
      );

      getHistory().push('/objetivo');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objetivoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default objetivoFormActions;
